import React from 'react';
import axios from './res/axios';
import App from './App';
import history from './history';
import { isTokenValid } from './utils';

class AuthControl extends React.Component {
  constructor(props){
    super(props);
    this.login = this.login.bind(this);
    this.authenticate = this.authenticate.bind(this);
    this.checkAuthStatus = this.checkAuthStatus.bind(this);
    this.setSession = this.setSession.bind(this);
    this.redirectToMidway = this.redirectToMidway.bind(this);

    this.state = {
      isLoggedIn: false,
      skipLogin: false
    }
    this.currentPathname = window.location.pathname
    console.log('current path:' + this.currentPathname)
  }

  componentWillMount() {
    if(process.env.NODE_ENV === 'production' && !window.location.pathname.startsWith('/error')) {
      this.authenticate();
    } else {
      this.setState(prevState => ({...prevState, skipLogin: true }));
    }
  }

  async authenticate() {
    const queryParams = (new URL(document.location)).searchParams;
    let idToken;

    // ID token would be in format /#id_token=<token_value>
    // Ideally we would just need to ensure:
    // - We match the id_token=<any-character> pattern to ensure that a token has come up after Midway login
    // - We should never design any API that would overlap with this path pattern
    const idTokenHash = document.location.hash.match(/#(?:id_token)=(.*)/);

    if (document.location.hash && idTokenHash){
      // Remove any trailing ampersand symbols (&) from the token
      idToken = idTokenHash[1].replace('&', '');
    }

    // If we are coming back from Midway after authentication.
    if(idToken) {
      console.info('id_token query parameter found.')
      if (await this.setSession(idToken)) {
        // setting the state as logged in
        this.setState(prevState => ({...prevState, isLoggedIn: true }));

        // remove the id_token query param from url
        queryParams.delete('id_token');
        // let newUrl = window.location.origin + window.location.pathname;
        let newUrl = window.location.pathname;
        if(queryParams.toString()){
          newUrl += '?' + queryParams.toString();
        }
        newUrl += window.location.hash;
        // history.replaceState({}, document.title, newUrl);
        console.log(' this is the new URI:' + newUrl)
        //This makes sure that if BOTSE_CURRENT_PATH exists that is the current user path so that should be taken.
        this.currentPathname = localStorage.getItem('BOTSE_CURRENT_PATH') ? localStorage.getItem('BOTSE_CURRENT_PATH') : this.currentPathname;
        console.log('about to replace: ' + window.location.origin + this.currentPathname)
        window.location.replace(window.location.origin + this.currentPathname);
        //history.replace(newUrl);
      } else {
        history.push('/error/500');
      }
      
    } else if (isTokenValid(localStorage.getItem('BOTSE_SESSION_TOKEN'))) {
        localStorage.removeItem('BOTSE_CURRENT_PATH')
        console.info('Token found in local storage is not expired yet.')
        this.setState(prevState => ({...prevState, isLoggedIn: true }));
    } else {
      // Corner case: Where valid cookie is present but session token is not present in local storage.
      // Forcing the user to login in again if the token in local storage. 
      console.info('Token not found in local storage / not valid.');
      localStorage.removeItem('BOTSE_SESSION_TOKEN');
      //BOTSE_CURRENT_PATH is used to store current path of the user. if teh user is directly opening the challenge
      //This attribute will help to store that so that the user is not redirected to home but to the desired path.
      localStorage.removeItem('BOTSE_CURRENT_PATH')
      localStorage.setItem('BOTSE_CURRENT_PATH', this.currentPathname);
      this.login(true);
    }
  }

  async login(force=false) {
    let data = await this.checkAuthStatus(force);
    console.debug('SSOLogin data : ', data);
    if(data['is_authenticated'] && data){
      this.setState(prevState => ({...prevState, isLoggedIn: true }));
    } else {
      this.redirectToMidway(data['authn_endpoint']);
    }
  }

  async setSession(idToken) {
    const body = {
      'token_present': true
    }
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8',
      'Authorization': idToken
    }

    try {
      let sessionToken = await axios.post('/sso/setsession', JSON.stringify(body), {headers: headers});
      localStorage.setItem('BOTSE_SESSION_TOKEN', sessionToken.data);
      // TODO: save session token to Redux
      // console.log("Set Session: ", sessionToken);
    } catch (error) {
      console.error('Unable to set session : ', error);
      return false;
    }
    return true;
  }

  redirectToMidway(authnEndpoint) {
    window.location.replace(authnEndpoint);
  }

  async checkAuthStatus(forceLogin=false) {
    let path = '/sso/login?redirectTo=' + window.location.origin;

    if(forceLogin) {
      path += '&forceLogin=true'
    }

    try {
      let result =  await axios.get(path);
      if(result.status === 200){
        return result.data;
      } else {
        console.error('Got the status code ' + result.status + ' while getting the login status');
      }
    } catch (error) {
      console.error('Unable to get login status : ', error);
    }
  }

  render() {
    const isLoggedIn = this.state.isLoggedIn;
    const skipLogin = this.state.skipLogin;
    let app;
    if(skipLogin || isLoggedIn){
      app = <App />
    } else {
      app = <div><h3>Checking your login status ....</h3></div>
    }

    return(
      <div className="awsui">
        {app}
      </div>
    )
  }

}

export default AuthControl;



// WEBPACK FOOTER //
// ./src/app/AuthControl.js